import React from 'react'
import { MeasureTypeRadioButtons } from './MeasureTypeRadioButtons'
import { useSizeFilter } from './useSizeFilter'
import { FilterGroup } from './FilterGroup'
import { Stack } from 'react-bootstrap'
import { SizeNumberInput } from './SizeNumberInput'

export const VerticalSize = () => {
  const { value, measureType, maximumValue, onChange, onChangeMeasureType, step } = useSizeFilter({ type: 'vertical' })

  return (
    <FilterGroup title="(Size) Vertical/Diameter" filterName="verticalSize">
      <Stack gap={2}>
        <SizeNumberInput value={value} onChange={onChange} maximumValue={maximumValue} step={step} />

        <MeasureTypeRadioButtons name="verticalMeasureTye" onChange={onChangeMeasureType} measureType={measureType} />
      </Stack>
    </FilterGroup>
  )
}
